export default () => {
  return {

    showButton: false,
    countOfHiddenCards: 0,
    visibleCardCount: 5,
    cardsPerClick: 5,
    numberOfCards: 0,

    init() {
      this.numberOfCards = this.$refs.listOfTalks.children.length;
      this.countOfHiddenCards = this.numberOfCards - 5;
      this.numberOfCards > 5 ? this.showButton = true : this.showButton = false;
    },
    showMore() {
      const cards = this.$refs.listOfTalks.children;
      this.visibleCardCount += this.cardsPerClick;


      Array.from(cards).forEach((card, index) => {
        if (card.classList.contains('hidden')) {
          if (index < this.visibleCardCount) {
            card.classList.remove('hidden');
          }
          card.scrollIntoView({ behavior: 'smooth', block: "center", inline: "nearest" });
        }
      });
      this.visibleCardCount >= this.numberOfCards ? this.showButton = false : this.showButton = true;
    }
  };
};
